var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatblue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 4.94558e-06C21.0218 4.94558e-06 17.2065 1.58188 14.3934 4.39775C11.5804 7.21361 10 11.0328 10 15.015C10.0382 17.6475 10.7343 20.2285 12.025 22.5225C12.1408 22.7262 12.2102 22.9528 12.2284 23.1864C12.2465 23.42 12.2129 23.6547 12.13 23.8738L11.125 27.2372C11.0483 27.4722 11.0666 27.728 11.1759 27.9497C11.2852 28.1714 11.477 28.3415 11.71 28.4234C11.9171 28.5062 12.148 28.5062 12.355 28.4234L15.355 27.5225C15.7439 27.4323 16.1484 27.4342 16.5364 27.5281C17.3074 27.7145 17.9301 28.2749 18.6483 28.6117C20.3618 29.4153 22.2151 29.8887 24.111 30.0029C26.4044 30.1411 28.6988 29.75 30.8174 28.8599C32.9359 27.9699 34.8218 26.6046 36.3297 24.8694C37.8375 23.1341 38.927 21.0754 39.5141 18.8519C40.1012 16.6284 40.1702 14.2996 39.7158 12.0452C39.2614 9.79079 38.2957 7.67103 36.8932 5.84939C35.4908 4.02776 33.6889 2.5529 31.6269 1.53871C29.5648 0.524528 27.2975 -0.00186139 25 4.94558e-06Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9652 15.03C29.9652 14.6499 30.0778 14.2783 30.2888 13.9622C30.4997 13.6462 30.7996 13.3998 31.1505 13.2544C31.5013 13.1089 31.8874 13.0709 32.2598 13.145C32.6322 13.2192 32.9744 13.4022 33.2429 13.671C33.5114 13.9398 33.6942 14.2822 33.7683 14.6551C33.8424 15.0279 33.8044 15.4143 33.6591 15.7655C33.5138 16.1167 33.2677 16.4169 32.9519 16.6281C32.6362 16.8393 32.265 16.9519 31.8853 16.9519C31.6338 16.9539 31.3844 16.906 31.1515 16.8111C30.9187 16.7161 30.7069 16.576 30.5284 16.3988C30.35 16.2215 30.2083 16.0106 30.1116 15.7782C30.0149 15.5459 29.9652 15.2967 29.9652 15.045V15.03ZM23.0502 15.03C23.0532 14.6505 23.1683 14.2804 23.3811 13.9663C23.5939 13.6523 23.8947 13.4083 24.2458 13.2651C24.5969 13.1219 24.9824 13.0861 25.3539 13.1619C25.7253 13.2377 26.066 13.422 26.333 13.6913C26.6001 13.9607 26.7815 14.3032 26.8543 14.6756C26.9272 15.048 26.8883 15.4336 26.7426 15.7839C26.5968 16.1342 26.3507 16.4336 26.0353 16.6441C25.7199 16.8546 25.3493 16.967 24.9702 16.967C24.7162 16.969 24.4645 16.9202 24.2296 16.8234C23.9948 16.7266 23.7816 16.5837 23.6027 16.4033C23.4238 16.2228 23.2828 16.0083 23.1879 15.7725C23.093 15.5366 23.0462 15.2842 23.0502 15.03ZM16.1353 15.03C16.1353 14.6499 16.2478 14.2783 16.4588 13.9622C16.6698 13.6462 16.9697 13.3998 17.3205 13.2544C17.6713 13.1089 18.0573 13.0709 18.4297 13.145C18.8022 13.2192 19.1443 13.4022 19.4128 13.671C19.6814 13.9398 19.8643 14.2822 19.9384 14.6551C20.0124 15.0279 19.9744 15.4143 19.829 15.7655C19.6837 16.1167 19.4376 16.4169 19.1219 16.6281C18.8061 16.8393 18.4349 16.9519 18.0552 16.9519C17.546 16.9519 17.0576 16.7495 16.6976 16.3891C16.3375 16.0286 16.1353 15.5397 16.1353 15.03Z",
    fill: "#F4FAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di",
    x: 0,
    y: 0,
    width: 50.0121,
    height: 50.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.74203,
    y1: -30.6306,
    x2: 46.6313,
    y2: -28.6271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatblue);
export default __webpack_public_path__ + "static/media/chatblue.e44ee1c4125c522db944adcd3f5bf394.svg";
export { ForwardRef as ReactComponent };